/**
 * Centralized Storage Service
 * Manages all localStorage and sessionStorage store
 */

const KEYS = {
  // Auth & Session
  TOKEN: "token",
  TOKEN_NEW: "tokenNew",
  LOGIN_ID: "LoginId",

  // Project Info
  PROJECT_ID: "ProjectId",
  PROJECT_NAME: "ProjectName",
  PROJECT_OWNER: "ProjectOwner",
  OPENING_YEAR: "OpeningYear",

  // User Info
  USER_NAME: "UserName",
  DESIGNATION: "Designation",

  // Feature Flags
  COA: "COA",
  IS_AI_AGENT_VISIBLE: "isAiAgentVisible",
  THEME: "app_theme",

  // Session Flags
  IS_PAID: "isPaid",
};

/**
 * localStorage store
 */
export const storage = {
  // Theme
  getTheme: () => "theme1",
  // getTheme: () => localStorage.getItem(KEYS.THEME) || "theme2",
  setTheme: (theme) => localStorage.setItem(KEYS.THEME, theme),
  removeTheme: () => localStorage.removeItem(KEYS.THEME),

  // Auth & Token
  getToken: () => localStorage.getItem(KEYS.TOKEN),
  setToken: (token) => localStorage.setItem(KEYS.TOKEN, token),
  removeToken: () => localStorage.removeItem(KEYS.TOKEN),

  getTokenNew: () => localStorage.getItem(KEYS.TOKEN_NEW),
  setTokenNew: (token) => localStorage.setItem(KEYS.TOKEN_NEW, token),
  removeTokenNew: () => localStorage.removeItem(KEYS.TOKEN_NEW),

  // Login & User
  getLoginId: () => localStorage.getItem(KEYS.LOGIN_ID),
  setLoginId: (id) => localStorage.setItem(KEYS.LOGIN_ID, id),
  removeLoginId: () => localStorage.removeItem(KEYS.LOGIN_ID),

  // Project
  getProjectId: () => localStorage.getItem(KEYS.PROJECT_ID),
  setProjectId: (id) => localStorage.setItem(KEYS.PROJECT_ID, id),
  removeProjectId: () => localStorage.removeItem(KEYS.PROJECT_ID),

  getProjectName: () => localStorage.getItem(KEYS.PROJECT_NAME),
  setProjectName: (name) => localStorage.setItem(KEYS.PROJECT_NAME, name),
  removeProjectName: () => localStorage.removeItem(KEYS.PROJECT_NAME),

  getProjectOwner: () => localStorage.getItem(KEYS.PROJECT_OWNER),
  setProjectOwner: (owner) => localStorage.setItem(KEYS.PROJECT_OWNER, owner),
  removeProjectOwner: () => localStorage.removeItem(KEYS.PROJECT_OWNER),

  getOpeningYear: () => localStorage.getItem(KEYS.OPENING_YEAR),
  setOpeningYear: (year) => localStorage.setItem(KEYS.OPENING_YEAR, year),
  removeOpeningYear: () => localStorage.removeItem(KEYS.OPENING_YEAR),

  // User Info
  getUserName: () => localStorage.getItem(KEYS.USER_NAME),
  setUserName: (name) => localStorage.setItem(KEYS.USER_NAME, name),
  removeUserName: () => localStorage.removeItem(KEYS.USER_NAME),

  getDesignation: () => localStorage.getItem(KEYS.DESIGNATION),
  setDesignation: (designation) => localStorage.setItem(KEYS.DESIGNATION, designation),
  removeDesignation: () => localStorage.removeItem(KEYS.DESIGNATION),

  // Feature Flags
  getCOA: () => localStorage.getItem(KEYS.COA),
  setCOA: (value) => localStorage.setItem(KEYS.COA, value),
  removeCOA: () => localStorage.removeItem(KEYS.COA),

  getIsAiAgentVisible: () => {
    const value = localStorage.getItem(KEYS.IS_AI_AGENT_VISIBLE);
    return value ? JSON.parse(value) : null;
  },
  setIsAiAgentVisible: (isVisible) =>
    localStorage.setItem(KEYS.IS_AI_AGENT_VISIBLE, JSON.stringify(isVisible)),
  removeIsAiAgentVisible: () => localStorage.removeItem(KEYS.IS_AI_AGENT_VISIBLE),

  // Generic store
  getItem: (key) => localStorage.getItem(key),
  setItem: (key, value) => localStorage.setItem(key, value),
  removeItem: (key) => localStorage.removeItem(key),

  // Clear all storage
  clearAll: () => {
    localStorage.clear();
    sessionStorage.clear();
  },

  // Clear localStorage only
  clearLocalStorage: () => localStorage.clear(),

  // Get all keys
  getAllKeys: () => Object.keys(localStorage),
};

/**
 * sessionStorage store
 */
export const sessionStore = {
  getIsPaid: () => sessionStorage.getItem(KEYS.IS_PAID),
  setIsPaid: (value) => sessionStorage.setItem(KEYS.IS_PAID, value),
  removeIsPaid: () => sessionStorage.removeItem(KEYS.IS_PAID),

  // Generic store
  getItem: (key) => sessionStorage.getItem(key),
  setItem: (key, value) => sessionStorage.setItem(key, value),
  removeItem: (key) => sessionStorage.removeItem(key),

  // Clear sessionStorage
  clearAll: () => sessionStorage.clear(),
};

// Export keys for direct access if needed
export { KEYS };

// eslint-disable-next-line import/no-anonymous-default-export
export default { storage, sessionStore, KEYS };
